import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Stack,
  Table,
  Form,
  Modal,
  FormGroup,
  FormLabel,
  Badge,
  InputGroup
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { isMobile, BrowserView } from "react-device-detect";
import ".././../assets/css/ListComponentsTable.css";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import PubSub from "pubsub-js";
import { LEAD_STATUS_VALUES, LIST_TAB_TITLE } from "../../constants/CONSTANT";
import { formatDate, formatDateForView, getUserDetails } from "../../utils/helper";
import DateRangePicker from "rsuite/DateRangePicker";
// (Optional) Import component styles. If you are using Less, import the `index.less` file.
import "rsuite/DateRangePicker/styles/index.css";
import InfoPill from "../InfoPill";
import { ROUTES } from "../../constants/webRouting";
import { CSVUpload } from "../../utils/CSVUpload";
import * as constants from "../../constants/CONSTANT";
import PERMISSIONS from "../../constants/permissions";
import moment from "moment";//Added by shahir hussain 15-12-2025
import UserMultiSelect from "../common/UserMultiSelect";
import ReadMoreText from "./ReadMoreText";
const LeadList = () => {
  const userInfo = getUserDetails();
  const navigate = useNavigate();
  const [body, setBody] = useState();
  const [contacts, setContacts] = useState();
  const [filterData, setFilterData] = useState({ lead_status: "Enquiry Pending" });
  const [dateRange, setDateRange] = React.useState([
    // new Date(),
    // new Date()
  ]);

  const [accounts, setAccounts] = useState([]);
  const [products, setProducts] = useState([]);
  //Added this all by shahir hussain 15-12-2025
  const [changeOwnerModal, setChangeOwnerModal] = useState(false);
  const [refreshRecords, setRefreshRecords] = useState(false);
  const [ownerLeads, setOwnerLeads] = useState([]);
  const [ownerLeadsHeader, setOwnerLeadsHeader] = useState([]);
  const [fromUser, setFromUser] = useState({});
  const [toUser, setToUser] = useState({});
  const tableRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [spinnerForChangeOwner, setSpinnerForChangeOwner] = useState(false);
  const [leadCities, setLeadCities] = useState([]);
  const [selectedToUsers, setSelectedToUsers] = useState([]);
  const [existNumber, setExistNumber] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState();

  //Ended this all by shahir hussain 15-12-2025

  const [leadStatusArray, setleadStatusArray] = useState(
    constants.LEAD_STATUS_VALUES
  );

  const [assignUsers, setAssignUsers] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // console.log("filterData == ", filterData)
    const filter = { ...filterData };
    delete filter.owner_name;
    delete filter.product_name;
    filter.owner_ids = filter?.owner_ids?.filter((item) => (item.value))?.map((item) => item.value);
    filter.account_id = filter?.accounts?.filter((item) => (item.value))?.map((item) => item.value);
    delete filter.accounts;
    if (Array.isArray(dateRange) && dateRange.length > 0) filter.date_range = { filed: 'createddate', createddate: { from: formatDate(dateRange?.at(0) || null), to: formatDate(dateRange?.at(1) || null), } };
    fetchLeads(filter);
  }, [dateRange, filterData]);

  async function fetchLeads(filter) {
    // console.log("fetchLeads == ", filter)
    const result = await fuziElevatorsApi.fetchLeads(filter);

    if (result) {
      setBody(result);
      setContacts(result);
    } else {
      setBody([]);
      setContacts([]);
    }
  }

  async function init() {
    if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some(permission => {
      return userInfo?.permissions.map(p => p.name).includes(permission);
    })) {
      const resultedUsers = await fuziElevatorsApi.fetchUsers();
      (resultedUsers && Array.isArray(resultedUsers)) && setAssignUsers(
        resultedUsers.map((user) => ({
          value: user.id,
          label: user.username,
        }))
      );
    }

    if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_MAKE].some(permission => {
      return userInfo?.permissions.map(p => p.name).includes(permission);
    })) {
      const resultedAccounts = await fuziElevatorsApi.fetchAccounts();
      (resultedAccounts && Array.isArray(resultedAccounts)) && setAccounts(resultedAccounts);
    }

    if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PRODUCT].some(permission => {
      return userInfo?.permissions.map(p => p.name).includes(permission);
    })) {
      const fetchedContacts = await fuziElevatorsApi.fetchProductsForEnquiry();
      Array.isArray(fetchedContacts) &&
        setProducts(
          fetchedContacts?.map((fetchedContact) => ({
            id: fetchedContact?.id,
            name: `${fetchedContact?.product_name || ""}`,
          }))
        );
    }
  }

  useEffect(() => {
    init();
  }, []);


  // // Create table headers consisting of 4 columns.
  const header = [];
  if (!isMobile) {
    header.push(
      {
        title: "Enquiry Number",
        prop: "enquiry_no",
        isFilterable: true,
        isSortable: true,
        cell: (row) => (
          <Link to={"/leads/" + row.id} state={row}>
            {row.enquiry_no}
          </Link>
        ),
      },
      //formatDateForView added by shahir hussain 27-08-2025
      {
        title: "Created Date",
        prop: "createddate",
        isFilterable: true,
        cell: (row) => (
          row?.createddate ? formatDateForView(row.createddate) : ''
        ),
        isSortable: true,
      },
      {
        title: "Name",
        prop: "lead_name",
        // cell: (row) => (
        //   <Link to={"/leads/" + row.id} state={row}>
        //     {row.lead_name}
        //   </Link>
        // ),
        isFilterable: true,
        //  isSortable: true,
      },

      {
        title: "Address",
        prop: "address",
        isFilterable: true,
        // isSortable: true,
      },

      {
        title: "City",
        prop: "city",
        isFilterable: true,
        // isSortable: true,
      },

      {
        title: "Phone",
        prop: "phone",
        isFilterable: true,
        // isSortable: true,

      },

      {
        title: "Make",
        prop: "accounts",
        // cell: (row) => (

        //   row.accounts?.map((item) =>
        //     item?.value && <>
        //       <Link to={`${ROUTES.ACCOUNT.LIST}/${item.value}`} >
        //         {item.label}
        //       </Link>
        //       <br />
        //     </>

        //   )),
        cell: (row) => {
          if (!row.accounts || row.accounts.length === 0) return "-";

          return (
            <span>
              {row.accounts.map((item, index) => (
                item?.value && (
                  <span key={item.value}>
                    <Link
                      to={`${ROUTES.ACCOUNT.LIST}/${item.value}`}
                      style={{ marginRight: "4px" }}
                    >
                      {item.label}
                    </Link>
                    {index < row.accounts.length - 1 && ", "}
                  </span>
                )
              ))}
            </span>
          );
        },

        isFilterable: true,
        //  isSortable: true,
      },

      {
        title: "Lead Type",
        prop: "leadtype",
        isFilterable: true,
        // isSortable: false,
      },

      {
        title: "Product",
        prop: "product_name",
        cell: (row) => (
          <Link to={`${ROUTES.PRODUCT.LIST}/${row.product_id}`} >
            {row.product_name}
          </Link>
        ),
        isFilterable: true,
      },

      {
        title: "Lead Status",
        prop: "lead_status",
        isFilterable: true,
        isSortable: true,
        alignment: { horizontal: "center" },
        cell: (row) => (
          <span
            className="badge rounded-pill w-100"
            style={getStatusClass(row.lead_status)}
          > 
            {row.lead_status}
          </span>
        ),
      },

      {
        title: "Lead Enquiry Status",
        prop: "lead_source_status",
        isFilterable: true,
        // isSortable: false,
      },


      // {
      //   title: "Assigned",
      //   prop: "owner_name",
      //   isFilterable: true,
      //   isSortable: true,
      //   cell: (row) => (
      //     <Link
      //       to={"/users/" + row.owner_id}
      //       state={row}
      //       className="align-items-center justify-content-start"
      //     >
      //       <img
      //         src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
      //         className="rounded-circle"
      //         style={{ height: "30px", width: "30px", objectFit: "cover" }}
      //         alt=""
      //       />
      //       <span className="mx-2">{row.owner_name}</span>
      //     </Link>
      //   ),
      // },
      {
        title: "Remark",
        prop: "remark",
        isFilterable: true,
        cell: (row) => (
          <ReadMoreText text={row.remark} wordLimit={20} />
        ),
      },

      {
        title: "Assign Users",
        prop: "owner_ids",
        cell: (row) => (
          <div className="d-flex flex-wrap gap-1">
            {row.owner_ids?.map((item, index) =>
              item?.value && (
                <Link
                  key={index}
                  to={`${ROUTES.USER.LIST}/${item.value}`}
                  state={row}
                  className="d-flex justify-content-center align-items-center px-2 py-1 rounded-pill shadow-sm text-decoration-none"
                  style={{
                    background: "#f5f7fa",
                    border: "1px solid #e0e0e0",
                    transition: "0.2s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#eaf1ff")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "#f5f7fa")}
                >
                  {/* <img
                    src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                    className="rounded-circle"
                    style={{
                      height: "30px",
                      width: "30px",
                      objectFit: "cover",
                      border: "2px solid #007bff",
                    }}
                    alt=""
                  /> */}
                  <span className="fw-semibold text-primary">{item.label}</span>
                </Link>
              )
            )}
          </div>
        ),

        isFilterable: true,
        isSortable: true,
      },
    );
  } else {
    //for mobile device

    header.push({
      title: "Info",
      prop: "name",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <div className="mobilecard">
          <Link
            to={"/contacts/" + row.id}
            state={row}
            style={{ width: "100%" }}
          >
            {row.firstname} {row.lastname}
          </Link>

          <span>
            <i className="fa-solid fa-phone"></i> {row.phone}
          </span>
          <span style={{ width: "80%" }}>
            <i className="fa-solid fa-envelope"></i> {row.email}
          </span>
        </div>
      ),
    });
  }
  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  //update by shahir hussain 24-12-2025
  const createLead = () => {
    setPhoneNumber('')
    setExistNumber(false)
    setShowPopup(true);
    // navigate(`/leads/e`);
  };

  //This is Using to Copy Form Url of Enquiry Form.
  const handleCopyLinkUrl = () => {
    let url = `${window.location.origin}/enquiry_form`;
    // navigator.clipboard
    //   .writeText(url)
    //   .then(() => {
    //     PubSub.publish("RECORD_SAVED_TOAST", {
    //       title: "Successfully",
    //       message: "Successfully Copied Enquiry Form Url",
    //     });
    //   })
    //   .catch((err) => {
    //     console.error("Failed to copy: ", err);
    //   });

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url)
        .then(() => PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Successfully",
          message: "Successfully Copied Enquiry Form Url",
        }))
        .catch((err) => {
          console.warn("Clipboard API failed, using fallback", err);
          // fallbackCopyToClipboard(url);
        });
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Error",
        message: "Field to Copy Enquiry Form Url",
      });
      // fallbackCopyToClipboard(url);
    }
  };



  //For Searching Filteration Clear.
  const handleClear = () => {
    setFilterData({});
    setDateRange([]);
    fetchLeads();
    // handleSearch();
  };

  const getStatusClass = (status) => {
    const statusObj = LEAD_STATUS_VALUES.find(
      (value) => value.label === status
    );
    return statusObj ? statusObj.css : {};
  };

  //Add this handlePhoneNumber by shahir hussain 24-12-2025
  const handlePhoneNumber = async (e) => {
    const value = e.target.value
    setPhoneNumber(value)
    if (value.length === 10) {
      try {
        const res = await fuziElevatorsApi.getAllPhone(value);
        if (res?.success) {
          console.log("res == ", res)
          setExistNumber(true)
          console.log("API response == ", res?.data);
          setBody(res?.data);
        } else {
          setExistNumber(false)
        }
      } catch (err) {
        console.log("API error == ", err);
        setExistNumber(false)
      }
    } else {
      setExistNumber(false)
    }

  }
  const handleChange = (e) => {

    setFilterData((pre) => ({ ...pre, [e.target.name]: e.target.value }));
  };

  const customFilter = (rows, filters) => {
    return rows.filter((row) => {
      return Object.keys(filters).every((column) => {
        const filterValue = filters[column]?.toLowerCase() || "";
        if (!filterValue) return true; // filter empty hai to row include karo

        const rowValue = row[column]?.toString().toLowerCase() || "";
        return rowValue.includes(filterValue); // substring + case-insensitive
      });
    });
  };

  //Added by shahir hussain for change user 15-12-2025
  useEffect(() => {
    (async () => {
      try {
        const fetchUsers = await fuziElevatorsApi.fetchUsersForListPage();
        const fetchContacts = await fuziElevatorsApi.fetchContacts();//For Ref Partner Filter According to Client Requiment.
        if (Array.isArray(fetchContacts)) {
          setContacts(fetchContacts?.map(({ id, firstname, lastname, phone }) => ({ value: id, label: `${firstname} - ${lastname} - ${phone}` })))//Set Contacts
        } else {
          setContacts([]);
        }
        if (Array.isArray(fetchUsers)) {
          setUsers(fetchUsers?.map(({ id, username, userrole }) => ({ value: id, label: `${username} - ${userrole}` })));
        } else {
          setUsers([]);
        }
      } catch (error) {
        console.error("Failed to load users/contacts:", error);
        setUsers([]);
        setContacts([]);
      }

    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        let allCitiesData
        // console.log("leadCities length == ", leadCities?.length)

        allCitiesData = await fuziElevatorsApi.citiesByFilter();

        if (allCitiesData?.success) {
          setLeadCities(allCitiesData?.result)
        } else {
          setLeadCities([])
        }
        console.log("allCitiesData == ", allCitiesData);
      } catch (error) {
        console.error("Failed to fetch cities:", error);
        setLeadCities([])

      }
    })();
  }, []);
  //Added by shahir hussain for change user 15-12-2025
  useEffect(() => {
    (async () => {
      if (fromUser && fromUser?.value) {
        setSpinnerForChangeOwner(true);
        const leads = await fuziElevatorsApi.getLeadsByStaffId(fromUser?.value);
        if (leads.success) {

          setOwnerLeads(leads?.data);
          setOwnerLeadsHeader([
            {
              title: <Form.Check // prettier-ignore
                type={"checkbox"}
                label="Select All"
                name="all_leads"
                onChange={handelCheckBox}
              />,
              prop: "id",
              isFilterable: true,
              cell: (row) => (
                <Form.Check // prettier-ignore
                  type={"checkbox"}
                  id={`${row.id}`}
                  name="leads"
                />
              ),
            },
            {
              title: "Name",
              prop: "leadname",
              isFilterable: true,
              cell: (row) => (
                <Link to={"/leads/" + row.id} state={row}>
                  {row.leadname}
                </Link>
              ),
            },
            {
              title: "Lead Status",
              prop: "lead_status",
              isFilterable: true, isSortable: true,
              // cell: (row) => {
              //   return (
              //     <Badge bg={getStatusClass(row.lead_status)} style={{ display: "block", paddingBottom: "5px" }}>
              //       {row.lead_status}
              //     </Badge>
              //   );

              // },
            },
            {
              title: "Created Date", prop: "createddate", isSortable: true, isFilterable: true, cell: (row) => (
                <span>
                  {moment(row.createddate).format('DD-MM-yyyy')}
                </span>
              )
            },
            {
              title: "Assigned",
              prop: "ownername",
              isFilterable: true,
              isSortable: true,
              cell: (row) => {
                const titleAbbreviations = {
                  "Sales Admin": "S. S.",
                  "Installation Admin": "I. A.",
                  "Accounts": "ACCOUNTS",
                  "Accounts Admin": "A. A.",
                  "Installation Engineer": "I. E.",
                  "Installation Supervisor": "I. S.",
                  "Business Development Executive": "B. D. E.",
                  "Customer Relationship Executive": "C. R. E.",
                  "Office": "OFFICE",
                  "Office Coordinator": "O. C.",
                  "Office Executive": "O. E.",
                  "Service Admin": "S. R.",
                  "SUPER_ADMIN": "SUPER_ADMIN" // If no abbreviation is needed
                };


                // Split ownername and ownerid arrays
                const ownerNames = row.ownername ? row.ownername.split(', ') : [];
                const ownerIds = row.ownerid ? row.ownerid : [];

                // Function to shorten titles
                const shortenTitle = (name) => {
                  const [fullName, title] = name.split(' - ');
                  const shortTitle = titleAbbreviations[title.trim()] || title; // Use abbreviation if available
                  return `${fullName} - ${shortTitle}`;
                };

                // Ensure ownerNames and ownerIds arrays are of the same length
                const links = ownerNames.map((name, index) => (
                  <Link
                    key={index} // Use index as key if ownerIds[index] is not reliable
                    to={`/users/${ownerIds[index]}`}
                    state={row}
                    className="align-items-center justify-content-start"
                  >
                    {shortenTitle(name)}<br />
                  </Link>
                ));
                return <span>{links}</span>;
              },
            },
          ]);
        }
        else {
          setOwnerLeads([]);
          setOwnerLeadsHeader([]);
        }
        setSpinnerForChangeOwner(false);
      } else {
        setOwnerLeads([]);
        setOwnerLeadsHeader([]);
      }
    })();
  }, [fromUser])

  //Added by shahir hussain for change user 15-12-2025
  const handelChangeOwnerModalClose = () => {
    setChangeOwnerModal(false);
    setRefreshRecords(!(refreshRecords));
    setOwnerLeads([]);
    setOwnerLeadsHeader([]);
    setFromUser({});
    setToUser({});
    setSelectedToUsers([])
  }

  //Added by shahir hussain for change user 15-12-2025
  const ChangeOwner = (e) => {
    e.preventDefault();
    let leads = [...(tableRef?.current?.querySelectorAll(`input[name='leads']`))];
    leads = leads?.filter((elm) => (elm.checked));
    leads = leads?.map((elm) => (elm.id));

    const toUsers = selectedToUsers.map(u => u.value);
    (async () => {
      const result = await fuziElevatorsApi.ChangeOwner({ fromUser: fromUser.value, toUser: toUsers, leads });
      if (result.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Transfer Owner', message: 'Owner Transfer successfully' });
        setSelectedToUsers([]);
        handelChangeOwnerModalClose();
      } else {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Transfer Owner Error', message: 'Some error occurred' });
      }
    })();
  }

  //Added by shahir hussain for change user 15-12-2025
  const handelFromUserSelect = (e) => {
    if (e) {
      setFromUser(e);
    }
    else {
      setFromUser(e);
    }
  }
  const handelToUserSelect = (e) => {
    setToUser(e)
  }

  const handelCheckBox = (e) => {
    [...(tableRef.current.querySelectorAll(`input[name='leads']`))].forEach((elm) => {
      elm.checked = e.target.checked;
    })
  }

  //Add this confirmPhoneModalClose by shahir hussain 24-12-2025
  const confirmPhoneModalClose = () => {
    setShowPopup(false)
    setPhoneNumber('')
    handleClear()
  }
  return (
    <Container fluid>
      <DatatableWrapper
        body={body && Array.isArray(body) ? body : []}
        headers={header}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 50,
            options: [5, 10, 15, 20, 30, 50]
          },
        }}
        sortProps={{ initialState: { prop: 'createddate', order: "desc" } }}
        filterFunction={customFilter}
      >
        <Row className="">
          {/* <p style={{ fontSize: "22px", display: "flex", justifyContent: "center", fontWeight: "bold" }}>Search Filter</p> */}
          <Col lg={2}>
            <Form.Group className="mt-2" >
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicState"
              >
                Product
              </Form.Label>

              <Select
                placeholder="Select your product"
                className="z-3"
                classNamePrefix="react-select"
                options={products?.map((product) => ({
                  value: product?.id,
                  label: product?.name,
                }))}
                onChange={(e) => {
                  handleChange({
                    target: { name: "product_id", value: e.value },
                  });
                  handleChange({
                    target: { name: "product_name", value: e.label },
                  });
                }}
                value={
                  filterData?.product_id
                    ? {
                      value: filterData?.product_id,
                      label: filterData?.product_name,
                    }
                    : ""
                }
              ></Select>
              <Form.Control.Feedback type="invalid">

              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" >
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicState"
              >
                Make
              </Form.Label>

              <Select
                isMulti
                className="z-3"
                classNamePrefix="react-select"
                placeholder="Select your makes"
                options={accounts?.map((account) => ({
                  value: account?.id,
                  label: account?.name,
                }))}
                onChange={(e) => {
                  handleChange({
                    target: { name: "accounts", value: e },
                  });
                }}
                value={
                  filterData?.accounts?.filter((item) => (item.value))
                }
              ></Select>
              <Form.Control.Feedback type="invalid">

              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" >
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicLead"
              >
                Lead Type
              </Form.Label>
              <Form.Select
                aria-label="Select lead type"
                name="leadtype"
                value={filterData?.leadtype || ""}
                onChange={handleChange}
              >
                <option value="">---Select---</option>
                {["New", "Modification", "AMC", "OneTime"].map(
                  (item, index) => (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  )
                )}
              </Form.Select>

              <Form.Control.Feedback type="invalid">
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" >
              <Form.Label>Lead Status</Form.Label>
              <Form.Select
                name="lead_status"
                value={filterData?.lead_status || ""}
                onChange={handleChange}
              >
                <option value="">--Select-Status--</option>
                {leadStatusArray.map((item, index) => (
                  <option value={item.label} key={index}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          {/* {console.log("leadCities == ", leadCities)} */}
          <Col lg={2}>
            <Form.Group className="mt-2" >
              <Form.Label>Area</Form.Label>
              <Form.Select
                name="city"
                value={filterData?.city || ""}
                onChange={handleChange}
              >
                <option value="">--Select-Cities--</option>
                {leadCities.map((item, index) => (
                  <option value={item.city} key={index}>
                    {item.city}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" >
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicLeadManagerId"
              >
                Assigned Users
              </Form.Label>
              <Select
                // isClearable
                className="z-3"
                isMulti
                name="owner_ids"
                classNamePrefix="react-select"
                onChange={(e) => {
                  handleChange({
                    target: { name: "owner_ids", value: e },
                  });
                }}
                value={
                  filterData?.owner_ids?.filter((item) => (item.value))
                }
                options={assignUsers}
              />
            </Form.Group>
          </Col>
          {/* Added By Farhan Khan on 26-Dec-2025 for Filter Added this Field (AMC Ticket )*/}
          <Col lg={2} className="mt-2">
            <Form.Group>
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicLeadSource"
              >
                Lead Enquiry Status
              </Form.Label>
              <Form.Select
                placeholder="Select lead enquiry status"
                aria-label="Select lead enquiry status"
                name="lead_source_status"
                value={filterData?.lead_source_status || ""}
                onChange={handleChange}
              >
                <option value="">---Select---</option>
                {["HOT", "WARM", "COLD"].map((item, index) => (
                  <option value={item} key={index}>
                    {item}
                  </option>
                ))}
              </Form.Select>

              <Form.Control.Feedback type="invalid">
                {/* {errors?.leadsource?.message} */}
              </Form.Control.Feedback>
            </Form.Group>
            {/* End By Farhan Khan on 26-Dec-2025 for Filter Added this Field (AMC Ticket) */}
          </Col>

        </Row>
        <Row className="align-items-end ">
          <Col className="">
            <Filter
              classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }}
            />
          </Col>
          <Col md={1} className="">
            <PaginationOptions labels={labels} />
          </Col>

          <Col>
            <DateRangePicker
              value={dateRange}
              onChange={(e) => {
                setDateRange(e);
              }}
              // format="dd/mm/yyyy"
              character=" – "
            />
          </Col>

          <Col className="py-1">
            <BrowserView>
              <div className="d-flex py-1 px-2 ">
                <InfoPill
                  left="Total"
                  right={body?.length}
                  rightClasses="bg-custom text-white border-white fw-bold"
                  leftClasses="bg-white text-danger fw-bold "
                />
              </div>
            </BrowserView>
          </Col>
          <Col lg={3} style={{ textAlign: "end" }}>
          </Col>
          <Col
            xs={12}
            sm={6}
            lg={3}
            className="d-flex flex-col justify-content-end align-items-end"
          >
            <Stack direction="horizontal" gap={2}>
              {/* Added by shahir hussain for change user 15-12-2025  */}
              {userInfo?.userrole === "SUPER_ADMIN" && (
                <Button onClick={() => (setChangeOwnerModal(true))} className="btn-sm" >Transfer Owner</Button>
              )
              }
              <Button variant="secondary" onClick={handleClear}><i class="fa fa-refresh" aria-hidden="true"></i></Button>
              {/* <CSVUpload userInfo={getUserDetails()} init={init} parent={"lead"}/> */}
              <Button
                size="sm"
                className="btn-create-enquiry"
                onClick={handleCopyLinkUrl}
              >
                Enquiry Form Url
              </Button>
              {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_LEAD].some(permission => {
                return userInfo?.permissions.map(p => p.name).includes(permission);
              }) && (
                  <Button
                    size="sm"
                    className="btn-create"
                    onClick={() => createLead(true)}
                  >
                    New Lead
                  </Button>
                )
              }
            </Stack>
          </Col>
        </Row>

        {/* <Table striped className="shadow rounded sm my-4" responsive={true}>
          <TableHeader classes={{ th: "bg-custom text-white" }} />
          {body && Array.isArray(body) ? (
            <TableBody />
          ) : (
            <tbody className="">
              <tr>
                <td colSpan={100} align="center">
                  <div>
                    <Spinner />
                  </div>
                </td>
              </tr>
            </tbody>
          )}
        </Table> */}
        <div className="table-scroll my-3">
          <Table striped className="shadow rounded sm my-4">
            <TableHeader classes={{ th: 'bg-custom text-white sticky-header' }} />
            {
              (body && Array.isArray(body)) ?
                <TableBody />
                :
                <tbody className="">
                  <tr>
                    <td colSpan={100} align="center">
                      <div>
                        <Spinner />
                      </div>
                    </td>
                  </tr>
                </tbody>
            }
          </Table>
        </div>
        <Pagination
          classes={{
            buttonGroup: "btn-custom",
            button: "bg-custom border-white",
          }}
        />
      </DatatableWrapper>

      {/* <>
        <Helmet>{LIST_TAB_TITLE.LeadList}</Helmet>
      </> */}

      {/* <Row className="g-0">
        <Col lg={12} className="px-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 20,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter/>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-start align-items-start"
                >
                  <PaginationOptions labels={labels} />
                  <div style={{marginTop: "3px"}}>
                  <BrowserView>
                    <InfoPill left="Total" right={body?.length} />
                  </BrowserView>
                  </div>
                  
                 
                </Col>
                
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button className="btn-sm" style={{marginRight: "10px"}} variant="success" onClick={handleCopyLinkUrl}>Enquiry Form Url</Button>
                  <Button
                    className="btn-sm"
                    variant="outline-primary"
                    onClick={() => createLead(true)}
                  >
                    New Contact
                  </Button>
                </Col>
              </Row>
              <Table striped className="data-table" responsive="sm">
                <TableHeader />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row> */}
      {/* <Footer></Footer>  */}

      {/* Added this modal by shahir hussain for change user 15-12-2025 */}
      {changeOwnerModal && <Modal
        show={changeOwnerModal}
        onHide={handelChangeOwnerModalClose}
        size={"xl"}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Transfer Owner
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={ChangeOwner} >
          <Modal.Body >
            <Row className="gap-3">
              <Col lg={12} >
                <Row className="">
                  <Col lg={6}>
                    <FormGroup>
                      <FormLabel>From</FormLabel>
                      <Select
                        isClearable
                        options={users}
                        onChange={handelFromUserSelect}
                        name="fromUser"
                        required
                        classNamePrefix="react-select"
                      >
                      </Select>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup>
                      {/* <FormLabel>To</FormLabel>
                      <Select
                        isClearable
                        options={users}
                        onChange={handelToUserSelect}
                        name="toUser"
                        required
                      >
                      </Select> */}
                      <UserMultiSelect
                        options={users}
                        value={selectedToUsers}
                        onChange={setSelectedToUsers}
                        label="To"
                      />
                    </FormGroup>
                  </Col>

                </Row>
              </Col>
              <Col lg={12} >
              </Col>
            </Row>
            {/* New Change : Enhanced the UI and adder loader */}
            {(fromUser && Object.keys(fromUser)?.length > 0) &&
              <Container style={{ height: "50vh", overflowY: "auto" }}>

                {!spinnerForChangeOwner ?
                  <DatatableWrapper
                    body={ownerLeads}
                    headers={ownerLeadsHeader}
                  >
                    <Table striped className="data-table" ref={tableRef}>
                      <TableHeader />
                      <TableBody />
                    </Table>
                  </DatatableWrapper>
                  :
                  <div className="d-flex justify-content-center align-items-center mt-5" >
                    <Spinner animation="border" variant="secondary" size="lg" />
                  </div>
                }
              </Container>
            }


          </Modal.Body>
          <Modal.Footer>
            <div className='submit'>
              <Button variant="success" type="submit" >
                Change
              </Button>
            </div>
            <Button onClick={handelChangeOwnerModalClose} variant="light">
              Close
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>}
      {/* Add this Confirm Phone Number Model by shahir hussain 24-12-2025*/}
      <Modal
        show={showPopup}
        dialogClassName="custom-modal-width"
        onHide={() => confirmPhoneModalClose()}
        style={{ marginTop: "50px" }} // top position
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Phone Number</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label className="form-view-label">Phone</Form.Label>
            {/* <InputGroup> */}
            <Form.Control
              type="text"
              name="phone"
              placeholder="Enter phone number"
              onChange={handlePhoneNumber}
              value={phoneNumber}
              maxLength={10}
              onKeyDownCapture={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab"
                ];
                if (e.ctrlKey || e.metaKey) return;
                if (!allowedKeys.includes(e.key) && isNaN(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {/* <Button onClick={() => { setPhoneNumber('') }}>X</Button> */}
            {/* </InputGroup> */}
          </Form.Group>
        </Modal.Body>

        {existNumber === true ? (
          <Modal.Footer className="d-flex flex-column align-items-center">
            <div
              style={{
                color: "red",
                fontWeight: "bold",
                fontSize: "1.1rem",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              This mobile number is already associated with another record.
            </div>
            <div
              style={{
                color: "red",
                fontWeight: "bold",
                fontSize: "1.1rem",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              Are you sure you want to create a new record with the same number?
            </div>

            <div className="d-flex gap-2">
              <Button variant="secondary" onClick={() => setShowPopup(false)}>
                Update Existing Record
              </Button>
              <Button variant="primary" onClick={() => navigate(`/leads/e`)}>
                Create New Record
              </Button>
            </div>
          </Modal.Footer>
        ) : <Modal.Footer>
          <Button variant="primary" onClick={() => navigate(`/leads/e`)}>
            Create New Record
          </Button>

          <Button variant="secondary" onClick={() => confirmPhoneModalClose()}>
            Close
          </Button>
        </Modal.Footer>}
      </Modal>


    </Container>
  );
};

export default LeadList;